// import axios from 'axios';

// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

// // Attach JWT token to every request
// api.interceptors.request.use(config => {
//   const token = localStorage.getItem('admin_token');
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // Handle 401 globally
// api.interceptors.response.use(
//   res => res,
//   err => {
//     if (err.response?.status === 401) {
//       localStorage.removeItem('admin_token');
//       localStorage.removeItem('admin_user');
//       window.location.href = '/login';
//     }
//     return Promise.reject(err);
//   }
// );

// // ── Auth ──
// export const login = (data) => api.post('/auth/login', data);
// export const getMe = () => api.get('/auth/me');
// export const changePassword = (data) => api.put('/auth/change-password', data);
// export const updateProfile = (data) => api.put('/auth/profile', data);

// // ── Dashboard ──
// export const getDashboardStats = () => api.get('/dashboard/stats');

// // ── Projects ──
// export const getProjects = (params) => api.get('/projects/admin/all', { params });
// export const getProject = (id) => api.get(`/projects/admin/${id}`);
// export const createProject = (data) => api.post('/projects', data);
// export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
// export const deleteProject = (id) => api.delete(`/projects/${id}`);

// // ── Quotations ──
// export const getQuotations = (params) => api.get('/quotations', { params });
// export const getQuotation = (id) => api.get(`/quotations/${id}`);
// export const updateQuotation = (id, data) => api.put(`/quotations/${id}`, data);
// export const deleteQuotation = (id) => api.delete(`/quotations/${id}`);

// // ── Contacts ──
// export const getContacts = (params) => api.get('/contacts', { params });
// export const markContactRead = (id) => api.put(`/contacts/${id}/read`);
// export const deleteContact = (id) => api.delete(`/contacts/${id}`);

// // ── Testimonials ──
// export const getTestimonials = () => api.get('/testimonials/admin/all');
// export const createTestimonial = (data) => api.post('/testimonials', data);
// export const updateTestimonial = (id, data) => api.put(`/testimonials/${id}`, data);
// export const deleteTestimonial = (id) => api.delete(`/testimonials/${id}`);

// // ── Services ──
// export const getServices = () => api.get('/services/admin/all');
// export const createService = (data) => api.post('/services', data);
// export const updateService = (id, data) => api.put(`/services/${id}`, data);
// export const deleteService = (id) => api.delete(`/services/${id}`);

// // ── Settings ──
// export const getSettings = () => api.get('/settings');
// export const updateSettings = (data) => api.put('/settings', data);

// // ── Upload ──
// export const uploadImages = (formData, onProgress) =>
//   api.post('/upload/images', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' },
//     onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / e.total))
//   });

// export const uploadVideo = (formData, onProgress) =>
//   api.post('/upload/video', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' },
//     onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / e.total))
//   });

// export const deleteFile = (filePath) => api.delete('/upload', { data: { filePath } });

// export default api;


import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'https://majesticwoodcrafts.com/api/v1';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  withCredentials: true,
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ── Auth ──────────────────────────────────
export const login = (data) => api.post('/auth/login', data);
export const logout = () => api.post('/auth/logout');
export const getMe = () => api.get('/auth/me');
export const changePassword = (data) => api.post('/auth/change-password', data);

// ── Dashboard ─────────────────────────────
export const getDashboardStats = () => api.get('/admin/dashboard/stats');

// ── Projects ──────────────────────────────
export const getAdminProjects = (params) => api.get('/admin/projects', { params });
export const createProject = (data) => api.post('/admin/projects', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getProject = (id) => api.get(`/admin/projects/${id}`);
export const updateProject = (id, data) => api.post(`/admin/projects/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteProject = (id) => api.delete(`/admin/projects/${id}`);
export const uploadProjectMedia = (id, data) => api.post(`/admin/projects/${id}/media`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteProjectMedia = (projectId, mediaId) => api.delete(`/admin/projects/${projectId}/media/${mediaId}`);

// ── Categories ────────────────────────────
export const getAdminCategories = () => api.get('/admin/categories');
export const createCategory = (data) => api.post('/admin/categories', data);
export const updateCategory = (id, data) => api.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`);

// ── Services ──────────────────────────────
export const getAdminServices = () => api.get('/admin/services');
export const createService = (data) => api.post('/admin/services', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateService = (id, data) => api.post(`/admin/services/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteService = (id) => api.delete(`/admin/services/${id}`);

// ── Testimonials ──────────────────────────
export const getAdminTestimonials = () => api.get('/admin/testimonials');
export const createTestimonial = (data) => api.post('/admin/testimonials', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateTestimonial = (id, data) => api.post(`/admin/testimonials/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteTestimonial = (id) => api.delete(`/admin/testimonials/${id}`);

// ── Quotations ────────────────────────────
export const getAdminQuotations = (params) => api.get('/admin/quotations', { params });
export const updateQuotationStatus = (id, data) => api.put(`/admin/quotations/${id}/status`, data);
export const deleteQuotation = (id) => api.delete(`/admin/quotations/${id}`);
export const getQuotationStats = () => api.get('/admin/quotations/stats');

// ── Contacts ──────────────────────────────
export const getAdminContacts = (params) => api.get('/admin/contacts', { params });
export const markContactRead = (id) => api.put(`/admin/contacts/${id}/read`);
export const deleteContact = (id) => api.delete(`/admin/contacts/${id}`);

export default api;